/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_ParallelInputs */



/**
* | output |
* | --- |
* | "Rounds in parallel" |
*
* @param {Tournament_Wiz_Kind_ParallelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_parallel = /** @type {((inputs?: Tournament_Wiz_Kind_ParallelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_ParallelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes en parallèle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas en paralelo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas em paralelo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round in parallelo")
	return /** @type {LocalizedString} */ ("Rounds in parallel")
});